import type React from "react";

import { colorsPalettes } from "@similarweb/styles";

import {
    StyledResizer,
    StyledTextarea,
    StyledTextareaWrapper,
} from "./styles";

type Props = {
    id?: string;
    value: string | undefined;
    onChange: (value: string | undefined) => void;
    onPaste?: (event: React.ClipboardEvent<HTMLTextAreaElement>) => void;
    placeholder?: string;
    disabled?: boolean;
    className?: string;
    width?: number | undefined;
};

export const Textarea = ({
    id,
    value,
    onChange,
    onPaste,
    disabled = false,
    placeholder = "",
    className,
    width = 604,
}: Props) => {
    const handleChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
        const newValue = event.target.value;
        onChange(newValue);
    };

    return (
        <StyledTextareaWrapper className={className}>
            <StyledTextarea
                id={id}
                value={value}
                onChange={handleChange}
                onPaste={onPaste}
                placeholder={disabled ? "" : placeholder}
                disabled={disabled}
                width={width}
            />
            <StyledResizer>
                <svg
                    width="8"
                    height="8"
                    viewBox="0 0 8 8"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M0 7.35032L0.649682 8L8 0.649682L7.35032 0L0 7.35032ZM3.67516 7.35032L4.32484 8L8 4.32484L7.35032 3.67516L3.67516 7.35032Z"
                        fill={colorsPalettes.midnight["100"]}
                    />
                </svg>
            </StyledResizer>
        </StyledTextareaWrapper>
    );
};
